<template>
    <Modal v-if="visible" :allowClose="false">
        <template #body>
            <div class="flex flex-col items-center">
                <p :class="paragraphStyle">
                    Hey there! Before you continue, we&apos;d love to get your
                    feedback.
                </p>
                <div class="mt-6 text-base won-blue">
                    Thank you for using the ResumAI! Please go to our survey
                    to answer a couple questions to let us know how we can improve
                    your experience.
                </div>
            </div>
        </template>

        <template #actions>
            <button :class="[buttonStyle]" @click="handleRedirect()">
                Go to survey
            </button>
        </template>
    </Modal>
</template>

<script>
import Modal from "../components/modal.vue";

import { buttonStyle, paragraphStyle } from "../utils/styles";

export default {
    components: {
        Modal,
    },
    emits: ["survey-modal:close"],
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        link: {
            type: String,
            required: true,
        },
    },
    setup({ link }) {
        return {
            link,
        };
    },
    data: () => ({ buttonStyle, paragraphStyle }),
    methods: {
        handleRedirect() {
            window.open(this.link, "_blank");
            this.$emit("survey-modal:close");
        },
    },
};
</script>

<style></style>
